import {styled} from '@mui/material/styles';
import {DataGrid} from '@mui/x-data-grid';

// TODO: move status-related styles to separate component
export const StyledTransactionsGrid = styled(DataGrid)(({theme})=>({
    'boxShadow': 2,
    'border': 0.5,
    '& .MuiDataGrid-cell:hover': {
        color: theme.palette.primary.main,
    },
    '& .type.inbound_transfer': {
        backgroundColor: '#1578b6',
    },
    '& .type.payout': {
        backgroundColor: '#1578b6',
    },
    '& .type.payout_cancel': {
        backgroundColor: '#ad210f',
    },
    '& .type.refund': {
        backgroundColor: '#f6ab2e',
    },
    '& .payment.manual': {
        backgroundColor: '#1578b6',
    },
    '& .status.new': {
        backgroundColor: '#1578b6',
    },
    '& .status.approved': {
        backgroundColor: '#1578b6',
    },
    '& .status.completed': {
        backgroundColor: '#3ed436',
    },
    '& .status.succeeded': {
        backgroundColor: '#3ed436',
    },
    '& .status.pending': {
        backgroundColor: '#f6ab2e',
    },
    '& .status.canceled': {
        backgroundColor: '#ad210f',
    },
    '&.MuiBox-root': {
        paddingBottom: '5px',
    },
    '&.MuiDataGrid-root .MuiDataGrid-cell:focus': {
        outline: 'none',
    },
    '&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus-within, .MuiDataGrid-root .MuiDataGrid-cell:focus-within': {
        outline: 'none',
    },
}));
